// NOTE: Environment variables are injected by webpack's DotEnv
// plugin. `process.env.X` is actually replaced at compile time by the actual
// value, so don't do anything fancy on those
export default class Config {
  static get API_URL() {
    return process.env.API_URL!;
  }

  static get PUBLIC_ASSETS_URL() {
    return process.env.PUBLIC_ASSETS_URL!;
  }

  static get VERSION(): string {
    // __VERSION comes from webpack's define plugin
    return __VERSION;
  }

  static get BRAND_LOGO_URL() {
    return process.env.PUBLIC_ASSETS_URL + '/brand-logo.png';
  }

  public static EVENT_DESCRIPTION_MAX_LENGTH = 200;
  public static DEFAULT_BLOCK_LENGTH = 15; // In minutes
}
